var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMstr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 131.000000 217.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,217.000000) scale(0.100000,-0.100000)",
    fill: "#fa660f",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210 2030 l0 -110 -95 0 -95 0 0 -830 0 -830 95 0 95 0 0 -115 0 -115 120 0 120 0 0 115 0 115 80 0 80 0 0 -115 0 -115 120 0 120 0 0 120 0 120 28 6 c135 29 235 83 297 159 146 177 143 461 -7 601 -48 45 -123 85 -186 99 l-33 7 59 56 c69 67 97 121 114 219 15 89 0 198 -39 285 -32 73 -114 150 -184 175 l-49 18 0 122 0 123 -120 0 -120 0 0 -110 0 -110 -80 0 -80 0 0 110 0 110 -120 0 -120 0 0 -110z m475 -426 c62 -32 85 -74 85 -153 0 -132 -57 -181 -222 -189 l-98 -5 0 188 0 187 98 -4 c73 -3 107 -9 137 -24z m11 -667 c106 -22 154 -72 154 -160 0 -131 -62 -171 -291 -184 l-109 -6 0 181 0 182 93 0 c50 0 120 -6 153 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMstr);
export default __webpack_public_path__ + "static/media/MSTR.e5c94ead193751a84d65dc41dad9eace.svg";
export { ForwardRef as ReactComponent };